import GiftGiverPreferencesApp from './gift-giver-preferences-app'

export default GiftGiverPreferencesApp
